<body id="style-2" class="back">
  <div class="header">
    <div class="container-fluid">
      <div class="row justify-content-between">
        <div class="col-lg-4">
          <div class="logo">
            <img
              src="{{ onPassiveBaseUrl }}onpassive(nov-30)/images/logo.png"
              alt="logo"
            />
          </div>
        </div>
        <div class="col-lg-5">
          <div class="social_box">
            <a
              href="http://onpassive.com/blog"
              target="_blank"
              rel="noopener"
              title="ONPASSIVE Blog"
            >
              <img
                src="{{ onPassiveBaseUrl }}onpassive(nov-30)/images/blog.png"
                alt="blog"
            /></a>
            <a
              href="https://www.facebook.com/ONPASSIVE/ONPASSIVE"
              target="_blank"
              rel="noopener"
              title="Facebook"
            >
              <img
                src="{{ onPassiveBaseUrl }}onpassive(nov-30)/images/fb.png"
                alt="facebook"
            /></a>
            <a
              href="https://twitter.com/ONPASSIVE"
              target="_blank"
              rel="noopener"
              ><img
                src="{{ onPassiveBaseUrl }}onpassive(nov-30)/images/twitter.png"
                alt="twitter"
                title="Twitter"
            /></a>
            <a
              href="https://www.linkedin.com/company/onpassiveofficial/company/onpassiveofficial"
              target="_blank"
              rel="noopener"
              ><img
                src="{{ onPassiveBaseUrl }}onpassive(nov-30)/images/in.png"
                alt="LinkedIn"
                title="Linkedin"
            /></a>
            <a
              href="https://www.youtube.com/c/ONPASSIVEc/ONPASSIVE"
              target="_blank"
              rel="noopener"
              ><img
                src="{{ onPassiveBaseUrl }}onpassive(nov-30)/images/youtube.png"
                alt="YouTube"
                title="Youtube"
            /></a>
            <a
              href="https://www.instagram.com/ONPASSIVE/"
              target="_blank"
              rel="noopener"
              title="Instagram"
              ><img
                src="{{ onPassiveBaseUrl }}onpassive(nov-30)/images/insta.png"
                alt="Instagram"
            /></a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-------------------body---------------------------->
  <section>
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-8">
          <marquee direction="up">
            <h1 class="font10">LAUNCHING SOON</h1>
          </marquee>
        </div>
        <div class="col-lg-4">
          <div class="video_box">
            <video
              id="my-video"
              class="
                video-js video-size
                w-100
                h-auto
                my-video-dimensions
                shadow
              "
              controls
              preload="auto"
              poster="{{ myLinksS3URL }}images/Image0231.png"
              data-setup="{}"
              autoplay="true"
              muted
            >
              <source
                src="{{
                  myLinksS3URL
                }}videos/Onpassive_launching_page_video2.mp4"
                type="video/mp4"
              />
            </video>
          </div>

          <a
            href="/registration/user?reg={{ userId }}"
            name="regform"
            target="_blank"
            rel="noopener"
          >
            <button class="btn btn-founder">Become a founder now</button>
          </a>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-4"></div>
        <div class="col-lg-4">
          <!-- <div class="box box1">-->
          <div class="box">
            <div>
              <span>
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(nov-30)/images/trimurl.png"
                  class="trimone"
                  alt="trimurl"
                />
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(nov-30)/images/trimurl1.png"
                  class="trimsecond"
                  alt="trumurl1"
                />
              </span>
              <span>
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(nov-30)/images/blog_logo.png"
                  class="blogone"
                  alt="blog_logo"
                />
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(nov-30)/images/blog_logo1.png"
                  class="blogsecond"
                  alt="blog_logo1"
                />
              </span>
              <span>
                <img
                  src="{{
                    myLinksS3URL
                  }}frontend/presentation22/images/logo.png"
                  class="blogone"
                  alt="o-founders_logo"
                />
                <img
                  src="{{
                    myLinksS3URL
                  }}frontend/presentation22/images/logo.png"
                  class="blogsecond"
                  alt="o-founders_logo1"
                />
              </span>
              <span
                ><img
                  src="{{ onPassiveBaseUrl }}onpassive(nov-30)/images/ai.png"
                  alt="AI"
                  class="blogone" />
                <img
                  src="{{ onPassiveBaseUrl }}onpassive(nov-30)/images/ai1.png"
                  alt="AI1"
                  class="blogsecond"
              /></span>
            </div>
          </div>
          <!-- </div>-->
        </div>
        <div class="col-lg-4"></div>
      </div>
    </div>
  </section>
  <!---------------------------------------------------->
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-5">
        <div class="row">
          <div class="col-lg-10">
            <div class="content">
              <h3 class="font1">
                Don't look back, you're not going that way. Life is now, right
                at this moment, and what lies ahead. We at ONPASSIVE believe in
                the future, helping thousands find their path in life. With the
                help of Artificial Intelligence, we specialize in providing
                fully automated online marketing business solutions. Get the
                best out of your business with the help of our unprecedented
                specialization. Experienced the unexperienced.
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6"></div>
    </div>
  </div>
  <!---------------------------------------------------->
  <!-- Optional JavaScript -->
  <!-- jQuery first, then Popper.js, then Bootstrap JS -->
</body>
